module.exports = __webpack_public_path__ + "img/atex_zone_2.79d31970.png";